import {
  Filter,
  FilterMatchingType,
} from "interfaces/filters";
import { TagType } from "interfaces/tags";

export const filtersDefs: Array<Filter> = [
  {
    name: 'name',
    label: 'Contract Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'customer',
    path: ['customer'],
    label: 'Customer Name',
    matching: FilterMatchingType.ARRAY_INCLUDES_CUSTOMERS_DROPDOWN_LAZY,
    key: 'name',
    value: [],
  },
  {
    name: 'status',
    path: [],
    label: 'Type/Status',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY,
    key: 'status',
    value: [],
    options: 'statusOptions',
  },
  {
    name: 'bookingDate',
    label: 'Booking Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'startDate',
    label: 'Start Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'endDate',
    label: 'End Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'cancelDate',
    label: 'Cancel Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'tags',
    path: ['tags'],
    label: 'Tags',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY_DROPDOWN,
    key: 'name',
    isArray: true,
    value: [],
    options: 'tags',
    tagType: TagType.CONTRACT,
  },
  {
    name: 'crmId',
    label: 'CRM ID',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
];